module.exports = "<div class=\"card image\" [ngClass]=\"[conf.expired ? 'expired' : tagType, conf.clickable ? 'hover-interact': '']\"\n  [ngStyle]=\"{height: cardHeight,  width: cardWidth}\">\n  <div class=\"image-div\" [ngStyle]=\"{ width: imageWidth, height: imageHeight}\">\n    <img [width]=\"imageWidth\" [height]=\"imageHeight\" [src]=\"thumbnail\" />\n  </div>\n  <div class=\"fullWidth\">\n    <ng-content select=\"itpx-card-details\" ngProjectAs=\"itpx-card-details\"></ng-content>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/common/banner-card/inner-course-card/inner-course-card.component.html
// module id = 925
// module chunks = 0